<template>
  <div class="section">
    <div class="container">
      <div class="columns is-centered">
        <div class="column is-half">
          <div class="section-block">
            <span class="title">WELCOME TO MUSTARD</span>
          </div>

          <p>
            Glad to have you on board! Lets start with your profile and put a
            face to your name, and confirm your details below!
          </p>

          <div class="columns is-centered profile-box">
            <div v-if="avatar" class="column is-narrow">
              <figure class="image is-180x180">
                <img :src="avatar" />
              </figure>
            </div>
          </div>

          <div class="is-block upload-box">
            <div class="level">
              <div class="level-left">
                <span v-if="photoFileName && this.form.avatar">{{
                  photoFileName
                }}</span>
                <span v-else>No image selected</span>
              </div>
              <div class="level-right">
                <b-upload accept="image/*" @input="onPhotoSelect">
                  <a class="button is-primary">
                    <span>Upload Image</span>
                  </a>
                </b-upload>
              </div>
            </div>
          </div>

          <div class="section-block tw-mt-16">
            <span class="title">CONFIRM YOUR DETAILS</span>
          </div>
          <validation-observer
            @submit.prevent="submit"
            tag="form"
            ref="onboard"
            v-slot="{ valid }"
          >
            <validation-provider
              vid="first_name"
              rules="required"
              name="first name"
              v-slot="{ errors }"
            >
              <b-field :message="errors" :type="{ 'is-danger': errors.length }">
                <b-input
                  v-model="form.first_name"
                  placeholder="First name"
                ></b-input>
              </b-field>
            </validation-provider>
            <validation-provider
              vid="last_name"
              rules="required"
              name="last name"
              v-slot="{ errors }"
            >
              <b-field :message="errors" :type="{ 'is-danger': errors.length }">
                <b-input
                  v-model="form.last_name"
                  placeholder="Last name"
                ></b-input>
              </b-field>
            </validation-provider>
            <validation-provider
              rules="required|email"
              name="email"
              v-slot="{ errors }"
            >
              <b-field :message="errors" :type="{ 'is-danger': errors.length }">
                <b-input
                  v-model="form.email"
                  placeholder="Email address"
                  type="email"
                ></b-input>
              </b-field>
            </validation-provider>
            <!-- Password -->
            <validation-observer ref="password">
              <validation-provider
                vid="password"
                name="password"
                rules="required|min:8|max:32|confirmed:password_confirmation"
                v-slot="{ errors }"
              >
                <b-field
                  :message="errors"
                  :type="{ 'is-danger': errors.length }"
                >
                  <b-input
                    v-model="form.password"
                    placeholder="Password"
                    type="password"
                  ></b-input>
                </b-field>
              </validation-provider>

              <validation-provider
                vid="password_confirmation"
                name="password confirmation"
                rules="required"
                v-slot="{ errors }"
              >
                <b-field
                  :message="errors"
                  :type="{ 'is-danger': errors.length }"
                >
                  <b-input
                    v-model="form.password_confirmation"
                    placeholder="Confirm password"
                    type="password"
                  ></b-input>
                </b-field>
              </validation-provider>
            </validation-observer>
            <validation-provider
              vid="phone_number"
              rules="required"
              name="phone number"
              v-slot="{ errors }"
            >
              <b-field :message="errors" :type="{ 'is-danger': errors.length }">
                <b-input
                  v-model="form.phone_number"
                  placeholder="Phone number"
                ></b-input>
              </b-field>
            </validation-provider>
            <validation-provider vid="address" v-slot="{ errors }">
              <b-field :message="errors" :type="{ 'is-danger': errors.length }">
                <b-input
                  v-model="form.address"
                  placeholder="Address (optional)"
                ></b-input>
              </b-field>
            </validation-provider>
            <validation-provider
              vid="school"
              rules="required"
              name="school or ministry"
              v-slot="{ errors }"
            >
              <b-field :message="errors" :type="{ 'is-danger': errors.length }">
                <b-input v-model="form.school" placeholder="School"></b-input>
              </b-field>
            </validation-provider>
            <validation-provider
              vid="year_level"
              name="year level"
              v-slot="{ errors }"
            >
              <b-field :message="errors" :type="{ 'is-danger': errors.length }">
                <b-input
                  v-model="form.year_level"
                  placeholder="Year Level (optional)"
                ></b-input>
              </b-field>
            </validation-provider>
            <validation-provider
              vid="group"
              name="church or youth group"
              v-slot="{ errors }"
            >
              <b-field :message="errors" :type="{ 'is-danger': errors.length }">
                <b-input
                  v-model="form.group"
                  placeholder="Church/Youth Group (optional)"
                ></b-input>
              </b-field>
            </validation-provider>

            <div class="section-block no-border">
              <span class="title is-size-5">
                I am currently part of a Christian Lunchtime Group at school
              </span>
            </div>

            <validation-provider
              vid="in_group"
              rules="required"
              name="is part of group"
              v-slot="{ errors }"
            >
              <b-field :message="errors" :type="{ 'is-danger': errors.length }">
                <div class="block">
                  <b-radio v-model="form.part_in_ltg" :native-value="true">
                    Yes
                  </b-radio>
                  <b-radio v-model="form.part_in_ltg" :native-value="false">
                    Not yet
                  </b-radio>
                </div>
              </b-field>
            </validation-provider>

            <!-- <div class="section-block no-border">
              <span class="title is-size-5">Message</span>
            </div>

            <validation-provider
              vid="message"
              rules="max:255"
              name="message"
              v-slot="{ errors }"
            >
              <b-field :message="errors" :type="{ 'is-danger': errors.length }">
                <b-input
                  v-model="form.message"
                  type="textarea"
                  placeholder="Message (optional)"
                ></b-input>
              </b-field>
            </validation-provider> -->

            <b-button
              :disabled="!valid || isSubmitting"
              native-type="submit"
              :loading="isSubmitting"
              class="is-pulled-right"
              type="is-primary"
              >Submit</b-button
            >
          </validation-observer>
        </div>
      </div>
    </div>

    <!-- Cropper modal -->
    <cropper @change="onPhotoCropped" ref="cropper" />
  </div>
</template>

<script>
import Cropper from '@/components/modals/Cropper'
import UploadMixin from '@/utils/mixins/upload'
import { each } from 'lodash'

export default {
  mixins: [UploadMixin],
  components: {
    Cropper
  },
  data() {
    return {
      isSubmitting: false,
      photoFileName: '',
      avatar: null,
      form: {
        token: '',
        first_name: '',
        last_name: '',
        email: '',
        phone_number: '',
        password: '',
        password_confirmation: '',
        avatar: '',
        address: '',
        school: '',
        year_level: '',
        group: '',
        part_in_ltg: false
      }
    }
  },
  mounted() {
    this.form.token = this.$route.query.token
    this.getUserInvitation()
  },
  methods: {
    getUserInvitation() {
      return this.$api
        .get(`/group-members/onboard/${this.form.token}`)
        .then(({ data }) => {
          this.form = {
            ...this.form,
            ...data.data
          }
        })
        .catch(() => {
          this.$router.replace({ name: 'home' })
        })
    },
    onPhotoSelect(file) {
      if (this.validateFileSize(file)) {
        this.photoFileName = file.name
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = e => {
          this.$refs.cropper.open(e.target.result)
        }
      }
    },
    onPhotoCropped(file) {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = e => {
        this.avatar = reader.result
        this.form.avatar = file
      }
    },
    login() {
      return this.$store
        .dispatch('auth/login', {
          username: this.form.email,
          password: this.form.password
        })
        .then(() => {
          this.$router.replace({ name: 'groups.details' })
        })
    },
    submit() {
      this.isSubmitting = true
      let formData = new FormData()
      formData.append('_method', 'PUT')
      each(this.form, (value, key) => {
        formData.append(key, value)
      })
      this.$api
        .post(`/group-members/onboard/${this.form.token}`, formData)
        .then(this.login)
        .catch(({ response }) => {
          if (response.data && response.data.errors) {
            this.$refs.onboard.setErrors(response.data.errors)
            this.$refs.password.setErrors(response.data.errors)
          }
        })
        .finally(() => {
          this.isSubmitting = false
        })
    }
  }
}
</script>
